import { useCallback, useMemo } from 'react';
import useScript from './hook';

export default function useBeacon() {
  const initBeacon = useCallback(() => {
    !(function (e, t, n) {
      if (
        ((e.Beacon = n =
          function (t, n, a) {
            e.Beacon.readyQueue.push({
              method: t,
              options: n,
              data: a,
            });
          }),
        (n.readyQueue = []),
        'complete' === t.readyState)
      );
    })(window, document, window.Beacon || function () {});

    window.Beacon('init', '5a40c9f3-34e6-4673-b7f7-2c7153411305');
    window.Beacon('config', { display: { zIndex: 9999 } });
  }, []);

  const destroyBeacon = useCallback(() => {
    if (window.Beacon) {
      window.Beacon('destroy');
      delete window.Beacon;
    }
  }, []);

  const options = useMemo(
    () => ({
      onInit: initBeacon,
      onRemove: destroyBeacon,
    }),
    [initBeacon, destroyBeacon],
  );

  useScript('https://beacon-v2.helpscout.net', options);
}
